import { TranslateService } from '@ngx-translate/core';
import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatMenuTrigger} from "@angular/material/menu";

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss'],
})
export class LanguagesComponent {
  @Output() languageClicked = new EventEmitter<void>();
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  constructor(
    public _translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  openMenu() {
    this.menuTrigger.openMenu();
  }


  changeLanguage(lang) {
    console.log('Languages component - changeLanguage called with:', lang)
    console.log('Current URL:', this.router.url);

    localStorage.setItem('LANG', lang);

    // Check if we're on a public page that requires language parameter in URL
    const currentUrl = this.router.url;

    if (currentUrl.includes('/public/distributors')) {
      // Navigate to distributors page with new language
      console.log('Navigating to distributors with language:', lang);
      this._translate.use(lang); // Set language first
      this.router.navigate(['/public/distributors', lang]);
      return;
    } else if (currentUrl.includes('/public/support-terms')) {
      // Navigate to support-terms page with new language
      console.log('Navigating to support-terms with language:', lang);
      this._translate.use(lang); // Set language first
      this.router.navigate(['/public/support-terms', lang]);
      return;
    } else if (currentUrl.includes('/public/service-providers')) {
      console.log('Navigating to service-providers with language:', lang);
      this._translate.use(lang);
      this.router.navigate(['/public/service-providers', lang]);
      return;
    }

    console.log('Using standard reload approach for other pages');
    // For other pages, use the standard reload approach
    this._translate.use(lang);
    window.location.reload();


    this.languageClicked.emit();
  }
}
